import config from '@/config';

// eslint-disable-next-line
declare let aptrinsic: any;

interface InitializeAnalyticsParams {
  username: string;
  applicationUserId: ID;
  roles: string[];
  isDragonflyUser: boolean;
  userTypeId: number;
  primaryOrganizationId: ID;
  primaryOrganizationName: string;
}

export const initializeAnalytics = ({
  applicationUserId,
  primaryOrganizationId,
  primaryOrganizationName,
  userTypeId,
  username,
  isDragonflyUser,
  roles,
}: InitializeAnalyticsParams) => {
  aptrinsic(
    'identify',
    {
      id: applicationUserId,
      primaryOrganizationId,
      userTypeId,
      username,
      email: username,
      primaryOrganizationName,
      isDragonflyUser,
      roles,
      environment: config.ENV,
      screenResolution: `${screen.width} x ${screen.height}`,
      browserResolution: `${window.innerWidth} x ${window.innerHeight}`,
    },
    {
      id: 'Roadrunner',
    }
  );
};
